import { SelectHTMLAttributes } from 'react';
import Form from 'react-bootstrap/Form';

interface OpcaoSelect {
  value: string | number;
  label: string;
}

interface SelectProps extends Omit<SelectHTMLAttributes<HTMLSelectElement>, 'value' | 'size'> {
  label?: string;
  value?: string | number;
  options: OpcaoSelect[];
  placeholder?: string;
}

export function Select({ label, options, placeholder, className, ...props }: SelectProps) {
  return (
    <Form.Group className="mb-3">
      {label && <Form.Label className="lizzi-form-label">{label}</Form.Label>}
      <Form.Select className={['lizzi-form-select', className].filter(Boolean).join(' ')} {...props}>
        {placeholder !== undefined && <option value="">{placeholder}</option>}
        {options.map((opcao) => (
          <option key={opcao.value} value={opcao.value}>
            {opcao.label}
          </option>
        ))}
      </Form.Select>
    </Form.Group>
  );
}
